import { Close } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableRoofProps } from '..';
import { ActionButtonList, TableRoofChipList, TableRoofFilter, TableRoofSearch } from '../shared';
import { ThreePointMenu } from '../../../../../threePointMenu';

type Props = Omit<TableRoofProps, 'variant' | 'onAddClick'>;
export const BaseRoof: FC<Props> = ({
  countOfEntries,
  chips,
  threePointMenuConfig,
  actionButtonConfig,
  selectedRowIds,
  onSearch,
  renderFilter,
  onDeselect,
  additionalComponent,
  customTableRoofHeadline
}) => {
  const { t } = useTranslation(['common', 'template']);
  const areRowsSelected = selectedRowIds && selectedRowIds.length > 0;

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        minHeight: '40px',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingX: '8px'
      }}
    >
      {countOfEntries !== undefined && countOfEntries !== 0 && (
        <Grid item sx={{ display: 'flex', marginRight: '12px' }}>
          <Typography variant="subtitle1" whiteSpace="nowrap">
            {areRowsSelected && `${selectedRowIds.length} `}
            {areRowsSelected && `${t('common:OF')} `}
            {customTableRoofHeadline ? (
              <>
                {countOfEntries} {customTableRoofHeadline}
              </>
            ) : (
              <>
                {countOfEntries} {t('template:ENTRIES', { count: countOfEntries })}
              </>
            )}

            {areRowsSelected && `${t('common:n')} ${t('common:SELECTED')}`}
          </Typography>
          {areRowsSelected && onDeselect && (
            <IconButton
              disableRipple
              size="small"
              sx={{
                padding: '0 3px',
                marginLeft: '8px',
                '&:hover > svg': {
                  color: 'grey.900'
                }
              }}
              onClick={onDeselect}
            >
              <Close fontSize="inherit" color="primary" />
            </IconButton>
          )}
        </Grid>
      )}
      <Grid item sx={{ flexGrow: 1 }}>
        {chips && chips.length > 0 && !areRowsSelected && (
          <TableRoofChipList
            chips={chips}
            justify={countOfEntries !== undefined && countOfEntries !== 0 ? 'center' : 'flex-start'}
          />
        )}
      </Grid>
      <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Box display={'flex'} alignItems={'center'}>
          {actionButtonConfig && areRowsSelected && (
            <ActionButtonList config={actionButtonConfig} selectedRowIds={selectedRowIds} />
          )}
          {onSearch && !areRowsSelected && (
            <Box>
              <TableRoofSearch onSearch={onSearch} variant="dark" />
            </Box>
          )}
          {renderFilter && !areRowsSelected && (
            <Box>
              <TableRoofFilter renderFilter={renderFilter} />
            </Box>
          )}
          {additionalComponent}
          {threePointMenuConfig && threePointMenuConfig.length > 0 && (
            <ThreePointMenu
              config={threePointMenuConfig}
              item={undefined}
              sx={{ padding: '8px' }}
            />
          )}
        </Box>
      </Grid>
    </Box>
  );
};
